import { useSelector } from 'react-redux';
import useMaterialLabelVisibility from '../../../../../common/material/hooks/use-material-label-visibility';
import cn from '../../../../../utils/classnames';
import getLabel from '../../../../../utils/material/get-label';
import { MaterialLabel } from '../../../../../utils/material/material-labels.constants';
import getMaterialLink from '../../../../../utils/url/get-material-link';

type Screen = 'desktop' | 'mobile';

type UseCardProps = { item: Material; screen: Screen; internalPath?: string; className?: string };
type UseCardReturn = { link: string; label: MaterialLabel; testId: string; classNames: string };

const useCard = (props: UseCardProps): UseCardReturn => {
    const { item, internalPath, screen, className } = props;

    const link = getMaterialLink(item, internalPath);

    const { countryCode } = useSelector((state: RootState) => state.main.geotargeting);
    const label = getLabel(item, countryCode);
    const showLabel = useMaterialLabelVisibility(item, label);

    const testId = `favorite-material-${item.id}`;

    const classNames = cn(`favorites-${screen}-material-card`, className, { 'with-label': showLabel });

    return { link, label, testId, classNames };
};

export default useCard;
